import { useCallback } from 'react';

import { useRoute } from 'hooks/navigation/use-route';
import { RunningExperiments, useExperiments } from 'state/experiments';
import { routes } from 'utils/routing';

interface IUseMenuReorderWidget {
  evaluateMenuReorderExperiment: () => boolean;
  isTreatmentEnabled: boolean;
}
enum MenuReorderWidgetExperimentVariants {
  CONTROL = 'control',
  TREATMENT = 'treatment',
}

export const useMenuReorderWidget = (): IUseMenuReorderWidget => {
  const { pathname } = useRoute();
  const menuReorderWidgetExperiment = RunningExperiments.MenuReorderWidget;
  const { variant, getVariantValue } = useExperiments();

  const isBaseRoute = pathname === routes.base;
  const isMenuRoute = pathname === routes.menu;

  const { value: experimentValue } = getVariantValue(menuReorderWidgetExperiment) || {};

  const isControl = isBaseRoute && experimentValue === MenuReorderWidgetExperimentVariants.CONTROL;
  const isTreatment =
    isMenuRoute && experimentValue === MenuReorderWidgetExperimentVariants.TREATMENT;

  const evaluateMenuReorderExperiment = useCallback(() => {
    // if the user is not assigned to the experienmt ( either control or treatment ),
    // we should keep the behavior as it is without logging exposure.
    if (!experimentValue && isBaseRoute) {
      return true;
    }

    if (isControl || isTreatment) {
      return variant(menuReorderWidgetExperiment, experimentValue);
    }
    return false;
  }, [experimentValue, isBaseRoute, isControl, isTreatment, variant, menuReorderWidgetExperiment]);

  return {
    evaluateMenuReorderExperiment,
    isTreatmentEnabled: isTreatment,
  };
};
